import React, { useState } from 'react'

// Replace with your actual WhatsApp number (include country code, no + or spaces)
const WHATSAPP_NUMBER = '918527130821'
const WHATSAPP_MESSAGE = 'Hello! I have a query about UniThink services.'

const WhatsAppButton = () => {
  const [hovered, setHovered] = useState(false)

  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`

  return (
    <>
      <style>{`
        .wa-btn-wrap {
          position: fixed;
          bottom: 28px;
          right: 28px;
          z-index: 9999;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .wa-tooltip {
          background: #fff;
          color: #128C7E;
          font-family: 'Inter', sans-serif;
          font-size: 13px;
          font-weight: 600;
          padding: 7px 14px;
          border-radius: 20px;
          box-shadow: 0 4px 20px rgba(0,0,0,0.15);
          white-space: nowrap;
          opacity: 0;
          transform: translateX(10px);
          transition: opacity 0.25s ease, transform 0.25s ease;
          pointer-events: none;
        }

        .wa-btn-wrap:hover .wa-tooltip {
          opacity: 1;
          transform: translateX(0);
        }

        .wa-btn {
          width: 58px;
          height: 58px;
          border-radius: 50%;
          background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 6px 24px rgba(37, 211, 102, 0.45);
          cursor: pointer;
          text-decoration: none;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
          position: relative;
        }

        .wa-btn:hover {
          transform: scale(1.1);
          box-shadow: 0 8px 30px rgba(37, 211, 102, 0.6);
        }

        .wa-btn svg {
          width: 30px;
          height: 30px;
          fill: #fff;
        }

        /* Pulse ring animation */
        .wa-btn::before {
          content: '';
          position: absolute;
          inset: -4px;
          border-radius: 50%;
          border: 3px solid rgba(37, 211, 102, 0.5);
          animation: wa-pulse 2s ease-out infinite;
        }

        @keyframes wa-pulse {
          0%   { transform: scale(1);   opacity: 0.8; }
          70%  { transform: scale(1.4); opacity: 0; }
          100% { transform: scale(1.4); opacity: 0; }
        }
      `}</style>

      <div className="wa-btn-wrap">
        <span className="wa-tooltip">Chat with us on WhatsApp</span>
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="wa-btn"
          aria-label="Chat on WhatsApp"
          id="whatsapp-float-btn"
        >
          {/* Official WhatsApp SVG icon */}
          <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 .4C7.4.4.4 7.4.4 16c0 2.7.7 5.3 2 7.6L.4 31.6l8.3-2.2C10.8 30.6 13.4 31.2 16 31.2c8.6 0 15.6-7 15.6-15.6C31.6 7.4 24.6.4 16 .4zm0 28.5c-2.4 0-4.7-.6-6.7-1.8l-.5-.3-5 1.3 1.3-4.8-.3-.5C3.6 20.7 3 18.4 3 16 3 8.8 8.8 3 16 3s13 5.8 13 13-5.8 12.9-13 12.9zm7.1-9.6c-.4-.2-2.3-1.1-2.6-1.2-.4-.1-.6-.2-.9.2s-1 1.2-1.2 1.5c-.2.2-.5.3-.9.1-.4-.2-1.7-.6-3.2-2-1.2-1.1-2-2.4-2.2-2.8-.2-.4 0-.6.2-.8l.6-.7c.2-.2.2-.4.4-.6.1-.2.1-.4 0-.6-.1-.2-.9-2.1-1.2-2.9-.3-.8-.6-.7-.9-.7h-.7c-.2 0-.6.1-1 .5-.3.4-1.3 1.3-1.3 3.1s1.3 3.6 1.5 3.9c.2.2 2.6 4 6.3 5.6.9.4 1.6.6 2.1.8.9.3 1.7.2 2.3.1.7-.1 2.3-.9 2.6-1.8.3-.9.3-1.7.2-1.8-.1-.1-.4-.2-.8-.4z" />
          </svg>
        </a>
      </div>
    </>
  )
}

export default WhatsAppButton
